var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.595 9.613",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#010101;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "My_Account_-_Profile",
    "data-name": "My Account - Profile"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.3,6.71,9.3.354a.583.583,0,0,1,1.072,0A1.617,1.617,0,0,1,10.6,1.2a1.617,1.617,0,0,1-.222.849L5.834,9.259a.583.583,0,0,1-1.072,0L.222,2.052A1.617,1.617,0,0,1,0,1.2,1.617,1.617,0,0,1,.222.354a.583.583,0,0,1,1.072,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.a30232c4517bbaccd5825d730e724104.svg";
export { ForwardRef as ReactComponent };